import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["loader"]

  connect() {
    this.observe()
  }

  disconnect() {
    this.unobserve()
  }

  loaderTargetConnected() {
    // When a new loader target appears (after turbo stream update), observe it
    this.observe()
  }

  loaderTargetDisconnected() {
    // Clean up when loader is removed
    this.unobserve()
  }

  observe() {
    if (!this.hasLoaderTarget) return

    // Clean up existing observer if any
    if (this.observer) {
      this.observer.disconnect()
    }

    this.observer = new IntersectionObserver(
      (entries) => this.handleIntersection(entries),
      {
        threshold: 0.1,
        rootMargin: "100px"
      }
    )

    this.observer.observe(this.loaderTarget)
  }

  unobserve() {
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // Click the load more link automatically when it comes into view
        this.loaderTarget.click()
      }
    })
  }
}
